import type { NativeStackScreenProps } from '@react-navigation/native-stack'
import { ActiveMinutes } from '@dialogue/services'
import type { Tracker } from '@dialogue/active-minutes'
import type { TrackerName } from '@dialogue/services/dist/active-minutes/model'

export type HealthTrackerSettingsScreenProps = NativeStackScreenProps<
  ReactNavigation.RootParamList,
  'healthTrackerSettings'
>

export type TrackerStatus =
  (typeof ActiveMinutes.Types.TrackerStatus)[keyof typeof ActiveMinutes.Types.TrackerStatus]

export type TrackerCtaStatusMap = Partial<Record<TrackerStatus | 'default', string>>

export interface TrackerSectionProps {
  supported: boolean
  provider: TrackerName | string
  status?: Tracker['status'] | TrackerStatus
  disabled?: boolean
  modifying?: boolean
  last_synced_at?: Tracker['last_synced_at']
  ctaStatusMap?: TrackerCtaStatusMap
  onPress: () => void
  temporaryDisabled?: boolean
  deprecated?: boolean
}

export enum SectionKey {
  CONNECTED = 'connected',
  SUPPORTED = 'supported',
  COMING_SOON = 'comingSoon',
}

export type TrackerListItem = Pick<Tracker, 'provider'> &
  Partial<Pick<Tracker, 'id' | 'status' | 'last_synced_at'>>

export type TrackerSectionConfig = {
  key: SectionKey
  title: string
  ctaStatusMap: TrackerCtaStatusMap
  trackers?: TrackerName[]
}
